'use client'

import React from 'react'
import GalleryGridLightbox24 from './GalleryGridLightbox24'
import GalleryMobileSlider24 from './GalleryMobileSlider24'

const GalleryResponsive = () => {
  return (
    <div className="w-full" id="galeria">
      {/* Título de la galería */}
      <div className="mb-8 text-center">
        <h2 className="text-3xl font-bold text-white">Galería de <span className="text-primary-blue">Experiencias</span></h2>
        <p className="mt-2 text-white/90">
          Descubre los momentos más increíbles de vuelo en parapente
        </p>
      </div>

      {/* Desktop: Grid tradicional (3×4) */}
      <div className="hidden lg:block">
        <div className="mb-4 text-center">
          <p className="text-white/90">
            <span className="font-semibold text-primary-blue">18</span> fotos disponibles • 
            Haz click en cualquier foto para ampliar
          </p>
          <p className="mt-1 text-sm text-white/80">
            Usa las flechas del teclado (← →) para navegar y ESC para cerrar
          </p>
        </div>
        <GalleryGridLightbox24 />
      </div>

      {/* Tablet: Versión intermedia (podría ser grid 2×4) */}
      <div className="hidden md:block lg:hidden">
        <div className="mb-4 text-center">
          <p className="text-white/90">
            <span className="font-semibold text-primary-blue">18</span> fotos • 
            Grid 2×4 para tabletas
          </p>
        </div>
        {/* Podríamos crear un componente específico para tablet, por ahora usamos el grid */}
        <div className="scale-95">
          <GalleryGridLightbox24 />
        </div>
      </div>

      {/* Móvil: Slider horizontal sin casillas vacías (2×3) */}
      <div className="block md:hidden">
        <GalleryMobileSlider24 />
      </div>


    </div>
  )
}

export default GalleryResponsive